import pageLoad from '../../middleware/page-load'

export default pageLoad
